import { render, staticRenderFns } from "./VulnSourceGitHubAdvisories.vue?vue&type=template&id=0197db40&"
import script from "./VulnSourceGitHubAdvisories.vue?vue&type=script&lang=js&"
export * from "./VulnSourceGitHubAdvisories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports